$('.slick').slick({
      loop: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 1,
      centerMode: false,
      dots: true,
      mobileFirst: true,
      arrows: false,
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.25
        }
      },
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          slidesToShow: 2.99
        }
      }
    ]
  });